import { Source } from '../../../../../../../../../core/models/imageAssets';

export const imagerySupportedSources: Source[] = [Source.SENTINEL, Source.DRONE, Source.PLANET];
